import { createMutex } from '@/services/async-mutex'

const answersMutex = createMutex()

export function withAnswersLock (fn) {
  return answersMutex.acquire(fn)
}
